<div style="display: flex; align-items: center">
  @let dataFromSignal = data();
  @let count = overflowCount();
  @if (isStringArray(dataFromSignal)) {
    @for (item of dataFromSignal; track item) {
      @if ($index < count) {
        <mc-tag
          [attr.data-cy]="item"
          [withaction]="withaction()"
          class="m-r-4 extra-height"
          [label]="item"
          variant="filled"
          [appearance]="appearance()"
          fit="small"
          padding="compact"
          (dismiss)="onCloseClicked(item)">
        </mc-tag>
      } @else {
        @if ($index === count) {
          <mc-popover style="position: relative" trigger="click" position="bottom-left">
            <div slot="trigger" class="overflow-count">+{{ data().length - count }}</div>
            <div class="tag-overflow-container">
              @for (item of dataFromSignal.slice(count); track item) {
                <mc-tag
                  [attr.data-cy]="item"
                  [withaction]="withaction()"
                  class="extra-height"
                  [label]="item"
                  variant="filled"
                  [appearance]="appearance()"
                  fit="small"
                  padding="compact"
                  (dismiss)="onCloseClicked(item)"></mc-tag>
              }
            </div>
          </mc-popover>
        }
      }
    }
  }

  @if (isCodeDescriptionArray(dataFromSignal)) {
    @for (item of dataFromSignal; track item.code) {
      @if ($index < count) {
        <mc-tag
          [attr.data-cy]="item.description"
          [withaction]="withaction()"
          class="m-r-4 extra-height"
          [label]="item.description"
          variant="filled"
          [appearance]="appearance()"
          fit="small"
          padding="compact"
          (dismiss)="onCloseClicked(item.code)">
        </mc-tag>
      } @else {
        @if ($index === count) {
          <mc-popover style="position: relative" trigger="click" position="bottom-left">
            <div slot="trigger" class="overflow-count">+{{ data().length - count }}</div>
            <div class="tag-overflow-container">
              @for (item of dataFromSignal.slice(count); track item.code) {
                <mc-tag
                  [attr.data-cy]="item.description"
                  [withaction]="withaction()"
                  class="extra-height"
                  [label]="item.description"
                  variant="filled"
                  [appearance]="appearance()"
                  fit="small"
                  padding="compact"
                  (dismiss)="onCloseClicked(item.code)"></mc-tag>
              }
            </div>
          </mc-popover>
        }
      }
    }
  }
</div>
